module.exports = __webpack_public_path__ + "public/files/img/banner.27bc9fc4.png";